import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-bold uppercase tracking-wider transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-dark-DEFAULT disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-gold hover:bg-gold-light text-black font-black shadow-[0_0_20px_rgba(255,215,0,0.4)] hover:shadow-[0_0_35px_rgba(255,215,0,0.7)] cta-pulse',
    secondary: 'bg-dark-100 hover:bg-dark-200 text-white border border-dark-200',
    danger: 'bg-danger hover:bg-red-600 text-white shadow-[0_0_15px_rgba(230,57,70,0.3)]',
    outline: 'bg-transparent border-2 border-gold text-gold hover:bg-gold/10'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={isLoading || disabled} {...props} data-id="element-213">
      {isLoading && <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-214" />}
      {children}
    </button>;
}